export default __webpack_public_path__ + "static/media/permitMenuIcon.01aeec5c.png";